import { FormBrandScreen } from "../screens/options/FormBrandScreen";
import { L192BrandScreen } from "../screens/options/L192BrandScreen";
import { MyBrandScreen } from "../screens/options/MyBrandScreen";
import { VendorListScreen } from "../screens/options/vendor/VendorListScreen";

export const OptionRoutes = [
  { path: "/options/brand/l192", exact: true, component: L192BrandScreen },
  { path: "/options/brand/list", exact: true, component: MyBrandScreen },
  { path: "/options/brand/create", exact: true, component: FormBrandScreen },
  { path: "/options/brand/edit/:id", exact: true, component: FormBrandScreen },
  { path: "/options/vendor/list", exact: true, component: VendorListScreen },
];
